import { useConfig } from "contexts/ConfigContext";

import TextLink from "components/TextLink";

import styles from "./SecuredByCodat.module.css";

export const SecuredByCodat: React.FC = () => {
  const config = useConfig();
  const show = config.state.data.showPoweredByCodat;

  return show ? (
    <TextLink
      href="https://help.codat.io"
      target="_blank"
      rel="noreferrer"
      analyticsName="Secured by Codat"
    >
      <img
        data-testid="secured-by-codat"
        className={styles.securedByCodat}
        src="https://static.codat.io/public/branding/secured-by-codat.svg"
        alt="Secured by Codat"
      />
    </TextLink>
  ) : (
    <></>
  );
};
